<template>
  <button
    class="filter-button button"
    v-on:click="onclick"
    v-bind:class="{
      active
    }"
    type="button"
  >
    <span>{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'FilterButton',
  props: {
    text: String,
    active: Boolean
  },
  methods: {
    onclick() {
      this.$emit('click');
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors';

.filter-button {
  height: 23px;
  border-radius: 20px;
  display: inline-block;
  box-sizing: border-box;
  padding: 0 20px;
  color: $independence;
  background-color: $babyPowder;
  font-size: 10px;
  font-family: "Source Sans Pro";
  transition: all .2s ease-in-out;
  cursor: pointer;
  position: relative;
  user-select: none;
  box-shadow: 0px 3px 6px #00000029;
  text-transform: capitalize;

  .icon {
    margin-left: 10px;
  }

  &.active {
    background-color: $geranium;
    color: $babyPowder;
  }
}
</style>
